export { default as useSWR } from './use-swr'
export type { SWRConfiguration } from 'swr'
